/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Popup from "vux/src/components/popup/index.vue";
import ViewBox from "vux/src/components/view-box/index.vue";
import PopupPicker from "vux/src/components/popup-picker/index.vue";
import Group from "vux/src/components/group/index.vue";
import XButton from "vux/src/components/x-button/index.vue";
import ScrollerList from '@/components/ScrollerList';
import ScrollerItem from '@/components/ScrollerList/ScrollerItem';
import SearchBar from '@/components/SearchBar';
import UserLogo from '@/components/UserLogo';
import Tags from '@/components/Tags';
import { getWorkerList, editCoordination, getAssignInfo } from '@/api';
export default {
  components: {
    Popup: Popup,
    ViewBox: ViewBox,
    PopupPicker: PopupPicker,
    Group: Group,
    XButton: XButton,
    ScrollerList: ScrollerList,
    ScrollerItem: ScrollerItem,
    SearchBar: SearchBar,
    UserLogo: UserLogo,
    Tags: Tags
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    // orderId: String,
    // visitId: String
    orderInfo: Object,
    coordList: {
      type: Array,
      default: []
    }
  },
  data: function data() {
    return {
      stateTagList: [],
      skillTagList: [],
      groupList: [],
      currValue: this.value,
      pageIndex: 0,
      pageSize: 10,
      keyword: '',
      params: {
        // searchGroupId: '',
        skill_label: '',
        state_label: ''
      },
      list: [],
      checkAssign: -1,
      // 指派人员id
      checkAssignImg: {
        name: '',
        url: ''
      },
      // 指派人员头像
      checkCoordList: [],
      //
      checkCoordListImg: [],
      slotsDefaultLength: 0
    };
  },
  computed: {
    // 计算滚动区域高度
    scrollerHight: function scrollerHight() {
      // eslint-disable-next-line
      var fontSize = window.getComputedStyle(window.document.documentElement)['font-size'];
      fontSize = Number(fontSize.substr(0, fontSize.length - 2));
      return document.documentElement.clientHeight - (4 + 4) * fontSize;
    }
  },
  watch: {
    value: function value(val) {
      var _this = this;

      this.currValue = val;
      this.checkAssign = this.orderInfo.fk_t_visit_user_id;
      this.checkAssignImg.name = this.orderInfo.visit_name;
      this.checkAssignImg.url = this.orderInfo.visit_avatar;

      if (val) {
        if (this.coordList && this.coordList.length > 0) {
          this.checkCoordListImg = this.list.filter(function (item) {
            return _this.coordList.some(function (crd) {
              return crd.id === item.id;
            });
          }).map(function (item2) {
            return {
              name: item2.name,
              url: item2.avatar
            };
          });
          this.checkCoordList = this.coordList.map(function (item) {
            return +item.id;
          });
        }
      }
    },
    currValue: function currValue(val) {
      var _this2 = this;

      if (val) {
        this.$setLeft({
          control: true,
          onSuccess: function onSuccess() {
            _this2.currValue = false;
          }
        });
      } else {
        this.$setLeft({
          control: false
        });
      }

      this.$emit('input', val);
    }
  },
  methods: {
    loadList: function loadList(op) {
      var _this3 = this;

      getWorkerList({
        pageIndex: this.pageIndex++,
        pageSize: this.pageSize,
        keyword: this.keyword,
        // searchGroupId: this.params.searchGroupId,
        skill_label: this.params.skill_label,
        state_label: this.params.state_label,
        roleId: 2
      }).then(function (res) {
        if (op === 'search') {
          _this3.list = [];
        }

        _this3.$refs['workerList'] && _this3.$refs['workerList'].donePullup();
        _this3.$refs['workerList'] && _this3.$refs['workerList'].donePulldown();

        if (res.success) {
          _this3.list = _this3.list.concat(res.data);

          if (res.data.length < _this3.pageSize) {
            _this3.$refs['workerList'] && _this3.$refs['workerList'].disablePullup();
          }
        } else {// 暂缺
        }
      });
    },
    resetList: function resetList() {
      // this.keyword = ''
      this.list = [];
      this.pageIndex = 0;
      this.$refs['workerList'].enablePullup();
      this.loadList('search');
    },
    reset: function reset() {
      this.params = {
        // searchGroupId: '',
        skill_label: '',
        state_label: ''
      }; // this.keyword = ''

      this.list = [];
      this.pageIndex = 0;
      this.$refs['workerList'].enablePullup();
      this.loadList('search');
    },
    onPulldownLoading: function onPulldownLoading() {
      this.resetList();
    },
    onPullupLoading: function onPullupLoading() {
      this.loadList();
    },
    onCheckOk: function onCheckOk(ids) {
      this.currValue = false;
      var names = this.list.filter(function (item) {
        return ids.indexOf(item.id) !== -1;
      }).map(function (item) {
        return item.name;
      });
      this.$emit('on-ok', ids, names);
    },
    // 选择指派人员
    assign: function assign(index) {
      var user = this.list[index];
      this.checkAssign = user.id;
      this.checkAssignImg.name = user.name;
      this.checkAssignImg.url = user.avatar; // 判断是否是协同 是的话去掉协同
      // let checkIndex = this.checkCoordList.indexOf(user.id)
      // if (checkIndex !== -1) {
      //   this.checkCoordList.splice(checkIndex, 1)
      //   this.checkCoordListImg.splice(checkIndex, 1)
      // }
    },
    // 选择协同人员
    coord: function coord(index) {
      var user = this.list[index];
      var checkIndex = this.checkCoordList.indexOf(user.id);

      if (checkIndex === -1) {
        this.checkCoordList.push(user.id);
        this.checkCoordListImg.push({
          name: user.name,
          url: user.avatar
        }); // 判断是否是指派 是的话去掉指派
        // if (this.checkAssign === user.id) {
        //   this.checkAssign = -1
        //   this.checkAssignImg = {}
        // }
      } else {
        this.checkCoordList.splice(checkIndex, 1);
        this.checkCoordListImg.splice(checkIndex, 1);
      }
    },
    // 编辑协同人员
    submit: function submit() {
      var _this4 = this;

      editCoordination({
        orderId: this.orderInfo.orderId,
        coordinations: this.checkCoordList.map(function (item) {
          return {
            id: item
          };
        }),
        id: this.checkAssign
      }).then(function (res) {
        if (res.success) {
          _this4.$vux.toast.text('编辑成功');

          _this4.currValue = false;

          _this4.$emit('on-success');
        } else {
          _this4.$vux.toast.text(res.message);
        }
      });
    },
    // 将16进制转为rgba
    hexToRgba: function hexToRgba(hex, opacity) {
      var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;

      if (hex && reg.test(hex)) {
        // 若为#FFF之类的4位色值 先转换成6位色值
        if (hex.length === 4) {
          var hexNew = '#';

          for (var i = 1; i < 4; i++) {
            hexNew += hex.slice(i, i + 1).concat(hex.slice(i, i + 1));
          }

          hex = hexNew;
        } // 处理6位色值 生成rgba


        var rgba = [];

        for (var _i = 1; _i < 7; _i += 2) {
          rgba.push(parseInt('0x' + hex.slice(_i, _i + 2)));
        }

        return "rgba(".concat(rgba.join(','), ", ").concat(opacity, ")");
      }
    }
  },
  created: function created() {
    var _this5 = this;

    this.loadList();
    getAssignInfo({
      code: 1
    }, {
      code: 2
    }).then(function (_ref) {
      var res1 = _ref.res1,
          res2 = _ref.res2,
          res3 = _ref.res3;
      _this5.stateTagList = res1.data.map(function (item) {
        var tem = {};
        tem['value'] = item.id.toString();
        tem['name'] = item.name;
        return tem;
      });
      _this5.skillTagList = res2.data.map(function (item) {
        var tem = {};
        tem['value'] = item.id.toString();
        tem['name'] = item.name;
        return tem;
      });
      _this5.groupList = res3.data.map(function (item) {
        var tem = {};
        tem['value'] = item.id.toString();
        tem['name'] = item.NAME;
        return tem;
      });
    });
  }
};